import o from "./index719.js";
import { renderSlot as e } from "vue";
import t from "./index720.js";
function n(r, a, p, s, d, f) {
  return e(r.$slots, "default", { handleKeydown: r.onKeydown });
}
var l = /* @__PURE__ */ t(o, [["render", n]]);
export {
  l as default
};
